import { sendGet } from "src/utils/sendApi";

export const progressApi = sendGet("v1/data/progress");